import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export const getAllTCs = createAsyncThunk(
  "getAllTCs",
  async ({ TCStatus, TcStage }) => {
    const token = localStorage.getItem("cu_user");
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/tc?stage=${TcStage}&status=${TCStatus}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return data.data;
    } catch (error) {
      console.error(error);
    }
  }
);

export const getTCDetails = createAsyncThunk("getTCDetails", async (tcId) => {
  const token = localStorage.getItem("cu_user");
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_HOST}/api/tc/${tcId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (error) {}
});

//assign to me
export const assignToMe = createAsyncThunk(
  "assignToMe",
  async ({ id, values }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const token = localStorage.getItem("cu_user");
        try {
          let response = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/tc/self-assign/${id}`,
            values,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (response.data.status === "success") {
            resolve(response);
            return response?.data;
          } else {
            reject(response?.data?.message);
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Assigning...",
        success: "Assigned to you successfully",
        error: {
          render({ data }) {
            return `${data?.message}`;
          },
        },
      }
    );
  }
);

//forwarded to L2
export const forwardToL2TC = createAsyncThunk(
  "forwardToL2TC",
  async ({ id, values }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const token = localStorage.getItem("cu_user");
        try {
          const res = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/tc/forwardToL2Approver/${id}`,
            values,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Processing...",
        success: "TC Application forwarded successfully",
        error: {
          render({ data }) {
            return `TC Application forwarded successfully`;
          },
        },
      }
    );
  }
);

// sent back to client
export const sentBackToClient = createAsyncThunk(
  "sentBackToClient",
  async ({ id, values }) => {
    return toast.promise(
      new Promise(async (resolve, reject) => {
        const token = localStorage.getItem("cu_user");
        try {
          const res = await axios.patch(
            `${process.env.REACT_APP_API_HOST}/api/tc/sendTcToClient/${id}`,
            values,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          if (res?.data?.status === "success") {
            resolve(res);
            return res?.data;
          }
        } catch (error) {
          reject(error?.response?.data);
        }
      }),
      {
        pending: "Processing...",
        success: "TC Application sent back to client successfully",
        error: {
          render({ data }) {
            return `${data.message}`;
          },
        },
      }
    );
  }
);

export const countsForTCAdmin = createAsyncThunk(
  "countsForTCAdmin",
  async () => {
    try {
      const token = localStorage.getItem("cu_user");
      const { data } = await axios.get(
        `${process.env.REACT_APP_API_HOST}/api/tc/agg-status/count`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    } catch (error) {}
  }
);

export const TCL1AdminSlice = createSlice({
  name: "TCL1Admin",
  initialState: {
    allTCs: [],
    TC: null,
    counts: [],
    status: "idle",
    error: null,
    isloading: true,
  },
  reducers: {},
  extraReducers: {
    [getAllTCs.pending]: (state) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getAllTCs.fulfilled]: (state, action) => {
      state.status = "success";
      state.allTCs = action.payload;
      state.isloading = false;
    },
    [getAllTCs.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = true;
    },
    [getTCDetails.pending]: (state, action) => {
      state.status = "pending";
      state.isloading = true;
    },
    [getTCDetails.fulfilled]: (state, action) => {
      state.status = "success";
      state.TC = action.payload;
      state.isloading = false;
    },
    [getTCDetails.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = true;
    },
    [countsForTCAdmin.pending]: (state, action) => {
      state.status = "pending";
      state.isloading = true;
    },
    [countsForTCAdmin.fulfilled]: (state, action) => {
      state.status = "success";
      state.counts = action.payload;
      state.isloading = false;
    },
    [countsForTCAdmin.rejected]: (state, action) => {
      state.status = "failed";
      state.error = action.error;
      state.isloading = true;
    },
  },
});

export default TCL1AdminSlice.reducer;
